import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  padding: 30px 40px;
  box-shadow: inset 2000px 0 0 0 rgba(255, 255, 255, 0.9);

  h2 {
    ${props => props.theme.css.heading3};
    color: ${props => props.theme.palette.primary.alphaDark};
    text-align: left;
    ${bp('lg')`
      text-transform: none;
    `}
  }

  .flex-columns {
    display: flex;
    justify-content: center;
    color: ${props => props.theme.palette.primary.alphaDark};
    margin-bottom: 40px;
    ${bp('lg')`
      flex-wrap: wrap;
      padding: 0 0 30px;
      margin: 0;
    `}

    > div {
      width: 50%;
      box-sizing: border-box;

      &:first-child {
        padding-right: 15px;
        ${bp('sm')`
          padding-right: 0;
        `}
      }

      ${bp('sm')`
        flex: 100%;
      `}
    }

    .img-wrapper {
      height: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      ${bp('sm')`
        min-height: 300px;
      `}
    }

    .column-right {
      ${bp('sm')`
        margin-top: 20px;
      `}

      div {
        border-bottom: 1px solid ${props => props.theme.palette.general.dark};

        &:not(:last-child) {
          margin-bottom: 12px;
        }
      }

      a {
        text-align: left;
        margin: 0;
        color: ${props => props.theme.palette.primary.alphaDark};
      }

      h3 {
        font: ${font('default', 'medium', '22px/1.2')};
        margin: 0 0 5px;
      }

      p {
        font: ${font('default', 'normal', '18px/1')};
        color: ${props => props.theme.palette.primary.alphaDark};
        margin: 0 0 15px;
        overflow: hidden;
        ${bp('sm')`
          height: 42px
        `}
      }
    }
  }

  a,
  .contact-trigger {
    display: block;
    text-decoration: none;
    max-width: 420px;
    margin: auto;
    cursor: pointer;
    text-align: center;
  }

  .contact-trigger {
    padding: 15px;
    width: 400px;
    border-radius: 10px;
    background: ${props => props.theme.palette.primary.beta};
    margin: 25px auto;
    box-shadow: 0 2px 12px -4px rgba(0, 0, 0, 0.75);
    text-transform: uppercase;
    font: ${font('default', 'bold', '20px/1.5')};
    color: ${props => props.theme.palette.general.light};
    ${bp('sm')`
      width: auto;
      font: ${font('default', 'bold', '18px/1.5')};
    `}
  }
`
